var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"height":"24","width":"24","xmlns":"http://www.w3.org/2000/svg"}},_vm.$listeners),[_c('path',{attrs:{"d":"M1 12a8 8 0 0 1 15.748-2H18a5 5 0 0 1 0 10H9a8 8 0 0 1-8-8z","fill-rule":"evenodd"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }